import React, { useState, useEffect } from 'react';
import { getConfiguracion, actualizarConfiguracion } from '../../services/api';

function Configuracion({ usuario }) {
  const [config, setConfig] = useState({
    tipo_periodo_pedido: 'diario',
    dias_anticipacion_pedido: '1',
    platos_minimos: '0',
    platos_maximos: '0',
    requiere_plato_principal: 'false',
    hora_limite_pedido_siguiente_dia: '14:00'
  });
  const [loading, setLoading] = useState(true);
  const [guardando, setGuardando] = useState(false);
  const [mensaje, setMensaje] = useState(null);

  useEffect(() => {
    cargarConfiguracion();
  }, []);

  // Verificar permisos
  if (usuario.tipo_usuario !== 'super_admin') {
    return (
      <div className="card" style={{ margin: '20px', padding: '40px', textAlign: 'center' }}>
        <h2 style={{ color: '#e74c3c', marginBottom: '20px' }}>🔒 Acceso Denegado</h2>
        <p style={{ fontSize: '16px', color: '#7f8c8d' }}>
          Solo los Super Administradores pueden acceder a la configuración del sistema.
        </p>
      </div>
    );
  }

  const cargarConfiguracion = async () => {
    try {
      const response = await getConfiguracion(usuario.dni);
      const configData = response.data;

      // Convertir array de configuraciones a objeto
      const configObj = {};
      configData.forEach(item => {
        configObj[item.clave] = item.valor;
      });

      setConfig({
        tipo_periodo_pedido: configObj.tipo_periodo_pedido || 'diario',
        dias_anticipacion_pedido: configObj.dias_anticipacion_pedido || '1',
        platos_minimos: configObj.platos_minimos || '0',
        platos_maximos: configObj.platos_maximos || '0',
        requiere_plato_principal: configObj.requiere_plato_principal || 'false',
        hora_limite_pedido_siguiente_dia: configObj.hora_limite_pedido_siguiente_dia || '14:00'
      });
    } catch (error) {
      console.error('Error cargando configuración:', error);
      setMensaje({ tipo: 'error', texto: 'Error al cargar la configuración' });
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setGuardando(true);
    setMensaje(null);

    try {
      // Enviar cada configuración individualmente
      await actualizarConfiguracion({
        tipo_periodo_pedido: config.tipo_periodo_pedido,
        dias_anticipacion_pedido: config.dias_anticipacion_pedido,
        platos_minimos: config.platos_minimos,
        platos_maximos: config.platos_maximos,
        requiere_plato_principal: config.requiere_plato_principal,
        hora_limite_pedido_siguiente_dia: config.hora_limite_pedido_siguiente_dia
      }, usuario.dni);

      setMensaje({
        tipo: 'success',
        texto: '✓ Configuración guardada correctamente. Los cambios se aplicarán en los próximos pedidos.'
      });
    } catch (error) {
      console.error('Error guardando configuración:', error);
      const errorMsg = error.response?.data?.error || 'Error al guardar la configuración';
      setMensaje({
        tipo: 'error',
        texto: errorMsg
      });
    } finally {
      setGuardando(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setConfig(prev => ({
      ...prev,
      [name]: value
    }));
  };

  if (loading) {
    return <div className="loading">Cargando configuración...</div>;
  }

  return (
    <div>
      <div className="page-header">
        <h1>⚙️ Configuración del Sistema</h1>
        <p>Configura el comportamiento general del sistema de pedidos</p>
      </div>

      <div className="card">
        <h2 style={{ marginBottom: '30px' }}>Configuración de Pedidos</h2>

        {mensaje && (
          <div
            className={`alert ${mensaje.tipo === 'error' ? 'alert-error' : 'alert-success'}`}
            style={{ marginBottom: '20px' }}
          >
            {mensaje.texto}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          {/* Tipo de Período */}
          <div className="form-group" style={{ marginBottom: '30px' }}>
            <label style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '10px', display: 'block' }}>
              Tipo de Período para Pedidos
            </label>
            <p style={{ fontSize: '14px', color: '#7f8c8d', marginBottom: '15px' }}>
              Define cada cuánto tiempo los usuarios pueden hacer sus pedidos
            </p>

            <div style={{ display: 'grid', gap: '15px' }}>
              {/* Opción Diario */}
              <label
                className={`config-option ${config.tipo_periodo_pedido === 'diario' ? 'selected' : ''}`}
                style={{
                  padding: '20px',
                  border: config.tipo_periodo_pedido === 'diario' ? '2px solid #27AE60' : '2px solid #e0e0e0',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  background: config.tipo_periodo_pedido === 'diario' ? '#f0f4ff' : 'white',
                  transition: 'all 0.2s'
                }}
              >
                <input
                  type="radio"
                  name="tipo_periodo_pedido"
                  value="diario"
                  checked={config.tipo_periodo_pedido === 'diario'}
                  onChange={handleChange}
                  style={{ marginRight: '10px' }}
                />
                <strong style={{ fontSize: '16px' }}>Diario</strong>
                <p style={{ marginLeft: '30px', fontSize: '14px', color: '#666', marginTop: '5px', marginBottom: 0 }}>
                  Los usuarios piden día por día (para mañana)
                </p>
              </label>

              {/* Opción Semanal */}
              <label
                className={`config-option ${config.tipo_periodo_pedido === 'semanal' ? 'selected' : ''}`}
                style={{
                  padding: '20px',
                  border: config.tipo_periodo_pedido === 'semanal' ? '2px solid #27AE60' : '2px solid #e0e0e0',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  background: config.tipo_periodo_pedido === 'semanal' ? '#f0f4ff' : 'white',
                  transition: 'all 0.2s'
                }}
              >
                <input
                  type="radio"
                  name="tipo_periodo_pedido"
                  value="semanal"
                  checked={config.tipo_periodo_pedido === 'semanal'}
                  onChange={handleChange}
                  style={{ marginRight: '10px' }}
                />
                <strong style={{ fontSize: '16px' }}>Semanal</strong>
                <p style={{ marginLeft: '30px', fontSize: '14px', color: '#666', marginTop: '5px', marginBottom: 0 }}>
                  Los usuarios piden para toda la semana (lunes a viernes)
                </p>
              </label>

              {/* Opción Quincenal */}
              <label
                className={`config-option ${config.tipo_periodo_pedido === 'quincenal' ? 'selected' : ''}`}
                style={{
                  padding: '20px',
                  border: config.tipo_periodo_pedido === 'quincenal' ? '2px solid #27AE60' : '2px solid #e0e0e0',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  background: config.tipo_periodo_pedido === 'quincenal' ? '#f0f4ff' : 'white',
                  transition: 'all 0.2s'
                }}
              >
                <input
                  type="radio"
                  name="tipo_periodo_pedido"
                  value="quincenal"
                  checked={config.tipo_periodo_pedido === 'quincenal'}
                  onChange={handleChange}
                  style={{ marginRight: '10px' }}
                />
                <strong style={{ fontSize: '16px' }}>Quincenal</strong>
                <p style={{ marginLeft: '30px', fontSize: '14px', color: '#666', marginTop: '5px', marginBottom: 0 }}>
                  Los usuarios piden para los próximos 15 días
                </p>
              </label>

              {/* Opción Mensual */}
              <label
                className={`config-option ${config.tipo_periodo_pedido === 'mensual' ? 'selected' : ''}`}
                style={{
                  padding: '20px',
                  border: config.tipo_periodo_pedido === 'mensual' ? '2px solid #27AE60' : '2px solid #e0e0e0',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  background: config.tipo_periodo_pedido === 'mensual' ? '#f0f4ff' : 'white',
                  transition: 'all 0.2s'
                }}
              >
                <input
                  type="radio"
                  name="tipo_periodo_pedido"
                  value="mensual"
                  checked={config.tipo_periodo_pedido === 'mensual'}
                  onChange={handleChange}
                  style={{ marginRight: '10px' }}
                />
                <strong style={{ fontSize: '16px' }}>Mensual</strong>
                <p style={{ marginLeft: '30px', fontSize: '14px', color: '#666', marginTop: '5px', marginBottom: 0 }}>
                  Los usuarios piden para todo el mes siguiente
                </p>
              </label>
            </div>
          </div>

          {/* Días de Anticipación */}
          <div className="form-group" style={{ marginBottom: '30px' }}>
            <label style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '10px', display: 'block' }}>
              Días de Anticipación
            </label>
            <p style={{ fontSize: '14px', color: '#7f8c8d', marginBottom: '15px' }}>
              Con cuántos días de anticipación los usuarios deben hacer sus pedidos
            </p>
            <select
              name="dias_anticipacion_pedido"
              value={config.dias_anticipacion_pedido}
              onChange={handleChange}
              className="form-control"
              style={{ maxWidth: '200px', fontSize: '16px', padding: '10px' }}
            >
              <option value="1">1 día (para mañana)</option>
              <option value="2">2 días</option>
              <option value="3">3 días</option>
              <option value="7">1 semana</option>
            </select>
          </div>

          {/* Hora Límite para Pedidos del Día Siguiente */}
          <div className="form-group" style={{ marginBottom: '30px' }}>
            <label style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '10px', display: 'block' }}>
              Hora Límite para Pedidos del Día Siguiente
            </label>
            <p style={{ fontSize: '14px', color: '#7f8c8d', marginBottom: '15px' }}>
              Hasta qué hora del día los usuarios pueden pedir el menú del día siguiente. Después de esta hora no se permitirán pedidos hasta el próximo día.
            </p>
            <input
              type="time"
              name="hora_limite_pedido_siguiente_dia"
              value={config.hora_limite_pedido_siguiente_dia}
              onChange={handleChange}
              className="form-control"
              style={{ maxWidth: '200px', fontSize: '16px', padding: '10px' }}
            />
            <small style={{ display: 'block', marginTop: '8px', color: '#95a5a6' }}>
              Ejemplo: Si configuras 14:00, los usuarios solo podrán pedir hasta las 14:00 hs del día actual
            </small>
          </div>

          {/* Validación de Platos */}
          <div style={{ borderTop: '2px solid #ecf0f1', paddingTop: '30px', marginTop: '30px' }}>
            <h3 style={{ marginBottom: '20px', color: '#2c3e50' }}>Validación al Cargar Menú</h3>
            <p style={{ fontSize: '14px', color: '#7f8c8d', marginBottom: '25px' }}>
              Estas configuraciones validan cuántos platos debe cargar el administrador por cada categoría al configurar el menú diario.
            </p>

            {/* Platos Mínimos */}
            <div className="form-group" style={{ marginBottom: '25px' }}>
              <label style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '10px', display: 'block' }}>
                Cantidad Mínima de Platos por Categoría
              </label>
              <p style={{ fontSize: '14px', color: '#7f8c8d', marginBottom: '15px' }}>
                Mínimo de opciones que debe haber en cada categoría del menú (0 = sin mínimo, permite días con pocas opciones)
              </p>
              <input
                type="number"
                name="platos_minimos"
                value={config.platos_minimos}
                onChange={handleChange}
                min="0"
                max="20"
                className="form-control"
                style={{ maxWidth: '150px', fontSize: '16px', padding: '10px' }}
              />
              <small style={{ display: 'block', marginTop: '8px', color: '#95a5a6', fontSize: '13px' }}>
                Ejemplo: Si configuras 2, cada categoría debe tener al menos 2 platos
              </small>
            </div>

            {/* Platos Máximos */}
            <div className="form-group" style={{ marginBottom: '25px' }}>
              <label style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '10px', display: 'block' }}>
                Cantidad Máxima de Platos por Categoría
              </label>
              <p style={{ fontSize: '14px', color: '#7f8c8d', marginBottom: '15px' }}>
                Máximo de opciones permitidas en cada categoría del menú (0 = sin máximo)
              </p>
              <input
                type="number"
                name="platos_maximos"
                value={config.platos_maximos}
                onChange={handleChange}
                min="0"
                max="20"
                className="form-control"
                style={{ maxWidth: '150px', fontSize: '16px', padding: '10px' }}
              />
              <small style={{ display: 'block', marginTop: '8px', color: '#95a5a6', fontSize: '13px' }}>
                Ejemplo: Si configuras 4, no se podrán cargar más de 4 platos por categoría
              </small>
            </div>

            {/* Requiere Plato Principal */}
            <div className="form-group" style={{ marginBottom: '30px', display: 'none' }}>
              <label style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '10px', display: 'block' }}>
                Obligar Plato Principal
              </label>
              <p style={{ fontSize: '14px', color: '#7f8c8d', marginBottom: '15px' }}>
                Cuando está activado, los usuarios deben seleccionar al menos un plato de la categoría "Principal"
              </p>
              <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', maxWidth: '300px' }}>
                <input
                  type="checkbox"
                  name="requiere_plato_principal"
                  checked={config.requiere_plato_principal === 'true'}
                  onChange={(e) => setConfig(prev => ({
                    ...prev,
                    requiere_plato_principal: e.target.checked ? 'true' : 'false'
                  }))}
                  style={{ width: '20px', height: '20px', marginRight: '10px' }}
                />
                <span style={{ fontSize: '15px' }}>Requiere al menos un plato Principal</span>
              </label>
            </div>
          </div>

          {/* Botones */}
          <div style={{ display: 'flex', gap: '10px', marginTop: '30px', paddingTop: '20px', borderTop: '1px solid #e0e0e0' }}>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={guardando}
              style={{ padding: '12px 30px', fontSize: '16px' }}
            >
              {guardando ? 'Guardando...' : '💾 Guardar Configuración'}
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={cargarConfiguracion}
              disabled={guardando}
              style={{ padding: '12px 30px', fontSize: '16px' }}
            >
              🔄 Recargar
            </button>
          </div>
        </form>
      </div>

      {/* Información Adicional */}
      <div className="card" style={{ marginTop: '20px', background: '#f8f9fa' }}>
        <h3 style={{ fontSize: '16px', marginBottom: '15px' }}>ℹ️ Información Importante</h3>
        <ul style={{ fontSize: '14px', lineHeight: '1.8', color: '#555', paddingLeft: '20px' }}>
          <li>Los cambios en la configuración se aplicarán <strong>solo para nuevos pedidos</strong></li>
          <li>Los pedidos ya realizados <strong>no se verán afectados</strong></li>
          <li>Asegúrate de tener el menú cargado para el período correspondiente</li>
          <li>Los usuarios verán un calendario o selector adaptado al período configurado</li>
          <li>La vista de Producción se adaptará automáticamente al período seleccionado</li>
        </ul>
      </div>
    </div>
  );
}

export default Configuracion;
